import { render, staticRenderFns } from "./ModeratorClasses.vue?vue&type=template&id=39f75285"
import script from "./ModeratorClasses.vue?vue&type=script&lang=js"
export * from "./ModeratorClasses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports